import { createSlice } from '@reduxjs/toolkit';

export enum PromoModalActions {
  SET_PROMO_MODAL = '@APP/SET_PROMO_MODAL'
}

export const INITIAL_PROMO_MODAL_STATE = {
  id: null,
  centreAlignText: false,
  markdown: '',
  title: ''
};

const promoModalSlice = createSlice({
  name: PromoModalActions.SET_PROMO_MODAL,
  initialState: INITIAL_PROMO_MODAL_STATE,
  reducers: {
    setPromoModal: (state, action: any) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  }
});

export const { setPromoModal } = promoModalSlice.actions;

export const promoModalReducer = promoModalSlice.reducer;
